<div #grid class="your-teams__grid">
  @if (showCreate()) {
    <button
      type="button"
      class="your-teams__tile your-teams__tile--create"
      (click)="createTeam.emit()"
      [attr.aria-label]="'teams.create-new-team' | translate"
    >
      <ocp-themed-icon class="your-teams__tile--create-icon" name="plus-circled.svg" [size]="18" />
      <span class="your-teams__tile-text">
        <span class="your-teams__tile-title">{{ 'teams.create-new-team' | translate }}</span>
        <span class="your-teams__tile-subtitle">
          {{ 'teams.create-team-subtitle' | translate }}
        </span>
      </span>
    </button>
  }

  @for (item of visibleItems(); track item.id) {
    <button
      type="button"
      class="your-teams__tile your-teams__tile--team"
      (click)="teamSelect.emit(item.id)"
      [attr.aria-label]="item.name"
    >
      <ocp-avatar [userInitials]="item.name" [colorSeed]="item.id" size="lg" singleInitial />
      <span class="your-teams__tile-text">
        <span class="your-teams__tile-title">{{ item.name }}</span>
        @if (item.projectCount !== undefined) {
          <span class="your-teams__tile-subtitle">
            {{
              (item.projectCount === 1 ? 'teams.project-count-one' : 'teams.project-count-other')
                | translate: { count: item.projectCount }
            }}
          </span>
        }
      </span>
    </button>
  }

  @if (showMoreVisible()) {
    <button
      type="button"
      class="your-teams__tile your-teams__tile--more"
      (click)="onShowMore()"
      [attr.aria-label]="'teams.show-more' | translate"
    >
      <span class="your-teams__more">{{ 'teams.show-more' | translate }}</span>
    </button>
  }
</div>
